<template>
  <div>
    <!-- 発着情報を表示する   -->
    <routeTable
      :reservation="Reservation"
      :selected-service="selectedService"
    />

    <!-- 確認項目の表示 -->
    <div class="confirmation-line">
      <confirmRow th="車両番号">
        <template #td>
          <span>{{ Reservation.sav.name }}</span>
        </template>
      </confirmRow>

      <confirmRow th="予約番号">
        <template #td>
          <span>{{ Reservation.reservationCode }}</span>
        </template>
      </confirmRow>

      <confirmRow th="人数">
        <template #td>
          <span v-if="Reservation.seatCount.adult">{{
            `おとな${Reservation.seatCount.adult}名 `
          }}</span>
          <span v-if="Reservation.seatCount.child">{{
            `こども${Reservation.seatCount.child}名 `
          }}</span>
          <span v-if="Reservation.seatCount.infant">{{
            `幼児${Reservation.seatCount.infant}名`
          }}</span>
        </template>
      </confirmRow>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheDemandComfirmation",
  props: {
    // 予約フローのBooking4では仮予約(tentativeReservation) 確認画面では本予約(Reservation)
    Reservation: {
      type: Object,
      require: true,
    },
    // 本予約(Reservation)の確認画面ではサービス内容をstoreに保持してないのでrequire: falseで、表示はそれを基準に分岐
    selectedService: {
      type: Object,
      require: false,
      default: null,
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped>
.confirmation-line {
  padding: 0 10px;
}

.route-table {
  margin: 20px 0;
  span {
    display: inline-block;
  }
  .depature_time {
    width: 25%;
  }
  .circle {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #888888;
    margin-right: 10px;
  }
  .port_name {
    font-weight: bold;
    width: 65%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.date {
  margin-left: 15px;
  margin-bottom: 5px;
}

.grey-bg {
  background: #f9f9f9;
  padding: 0;
  padding-left: 10px;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  height: 35px;
  position: relative;
}

.grey-bg div {
  position: absolute;
  top: 50%;
  width: 95%;
  transform: translate(0%, -50%);
  -webkit-transform: translate(0%, -50%);
  -ms-transform: translate(0%, -50%);
}

.blue-line {
  background: white;
}

.blue-line::before {
  content: "";
  content: "";
  left: 4px;
  position: relative;
  background: #2a7aff;
  border-right: 3px solid transparent;
  border-bottom: 18px solid transparent;
  border-top: 16px solid transparent;
}
</style>
